// src/core/reusables/ProgressContext.js
import React, { createContext, useContext, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  LinearProgress,
  Typography,
} from "@mui/material";

const ProgressContext = createContext();

export const ProgressProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("Loading...");

  const startProgress = (msg = "Processing...") => {
    setLoading(true);
    setProgress(0);
    setMessage(msg);
  };

  const updateProgress = (value, msg) => {
    setProgress(value);
    if (msg) setMessage(msg);
  };

  const stopProgress = () => {
    setProgress(100);
        setTimeout(() => {
        setLoading(false);
        setProgress(0);
        setMessage("Loading...");
        }, 600);
  };

  return (
    <ProgressContext.Provider
      value={{ loading, progress, message, startProgress, updateProgress, stopProgress }}
    >
      {children}
      <GlobalProgressUI loading={loading} progress={progress} message={message} />
    </ProgressContext.Provider>
  );
};

export const useProgress = () => useContext(ProgressContext);

// UI Component
const GlobalProgressUI = ({ loading, progress, message }) => {
  if (!loading) return null;

  return (
        <Backdrop
        open={loading}
        sx={{
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1000,
            flexDirection: "column",
            backdropFilter: "blur(6px)",
        }}
        >
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            bgcolor="background.paper"
            p={3}
            borderRadius={3}
            boxShadow={3}
            minWidth="260px"
        >
            <CircularProgress
            variant={progress >= 100 ? "indeterminate" : "determinate"}
            value={progress}
            size={60}
            thickness={4}
            color="primary"
            />
            <Typography variant="h6" color="text.primary" mt={2}>
            {message}
            </Typography>
            <Typography variant="body2" color="text.secondary">
            {progress < 100 ? `${progress}%` : "Finalizing..."}
            </Typography>
            <Box width="100%" mt={2}>
            <LinearProgress
                variant="determinate"
                value={progress}
                sx={{ height: 6, borderRadius: 5 }}
            />
            </Box>
        </Box>
        </Backdrop>
    );
};
